import { render, staticRenderFns } from "./ActivityRoomRow.vue?vue&type=template&id=701ddb9a&"
import script from "./ActivityRoomRow.vue?vue&type=script&lang=js&"
export * from "./ActivityRoomRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports